import {BreakdownAddress} from './address.model';

export class BreakdownProposer {
  proposer_type = '';
  company_name = '';
  trading_name: string = '';
  is_micro_enterprise: number | boolean | null = null;
  year: number = null;
  address: any = new BreakdownAddress();
  is_phone = 0;
  sms = 0;
  is_email = 0;
  post = 0;
}
